module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bloodyMarry_4436c3.jpg";